export interface RefreshableComponent {
  refreshData(): void;
}
